'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var introducerUrls = exports.introducerUrls = {
  advertiser: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/advertisers',
  // ?product=fdi TODO - remove markerstudy
  instructor: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/instructors' // ?query=Acc&product=fdi
};
var addressLookupUrls = exports.addressLookupUrls = {
  find: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/address-lookup-proxy/Find/v1.1/json3.ws',
  retrieve: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/address-lookup-proxy/Retrieve/v1.2/json3.ws'
};
var employmentUrls = exports.employmentUrls = {
  occupations: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/markerstudy/occupations',
  // ?query=Acc&product=fdi
  industries: process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/markerstudy/business-types' // ?query=Air&product=ldi'
};
var vehicleLookupUrls = exports.vehicleLookupUrls = function vehicleLookupUrls(product) {
  return {
    reg: process.env.REACT_APP_API_BASE_URI + '/' + (product === 'all' ? 'shared' : product) + '/v1/reg-lookup',
    manual: process.env.REACT_APP_API_BASE_URI + '/' + (product === 'all' ? 'shared' : product) + '/v1/vehicle-lookup'
  };
};